import React, { useEffect, useState } from 'react';
import { styled, useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import ManIcon from '@mui/icons-material/Man';
import CssBaseline from '@mui/material/CssBaseline';
import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import IconButton from '@mui/material/IconButton';
import Man3Icon from '@mui/icons-material/Man3';
import Menu from '@mui/material/Menu';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import MenuIcon from '@mui/icons-material/Menu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import CottageIcon from '@mui/icons-material/Cottage';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import SearchIcon from '@mui/icons-material/Search';
import MapIcon from '@mui/icons-material/Map';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Chip, Divider, Tooltip, Typography, CircularProgress } from '@mui/material';
import { getUser, logout } from '../core/services/authService';
import { LOGOUT } from '../core/store/slice/authSlice';
import logo from '/assets/logo.png';
import Avatar from '@mui/material/Avatar';
import Super_admin from '../../public/assets/Super_admin.png';
import Originaztion_admin from '../../public/assets/Originaztion_admin.png';
import logoAgent from '../../public/assets/logo-agent.png';
import LogoSales from '../../public/assets/LogoSales.svg';
import { GetRoutes } from '../core/Routes/Routes';
import PeopleIcon from '@mui/icons-material/People';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import DialogContentText from '@mui/material/DialogContentText';
import DialogContent from '@mui/material/DialogContent';
import ICALEADS from '../components/ICAModule/IcaLeads/ICALEADS';
import ICALeadProfile from '../components/ICAModule/IcaProfile/ICALeadProfile';
import PersonIcon from '@mui/icons-material/Person';
import MenuItem from '@mui/material/MenuItem';
import LockIcon from '@mui/icons-material/Lock';
import HomeIcon from '@mui/icons-material/Home';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import Diversity1Icon from '@mui/icons-material/Diversity1';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import ChatIcon from '@mui/icons-material/Chat';
import Collapse from '@mui/material/Collapse';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import WorkHistoryIcon from '@mui/icons-material/WorkHistory';
import PersonSearchIcon from '@mui/icons-material/PersonSearch';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import AddLocationAltIcon from '@mui/icons-material/AddLocationAlt';
import ContentPasteGoIcon from '@mui/icons-material/ContentPasteGo';
import toast from 'react-hot-toast';
import LeadService from '../core/services/leadsService';
import ReportIcon from '@mui/icons-material/Report';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import DashboardIcon from '@mui/icons-material/Dashboard';
import LogoutExpiredModal from '../components/LogoutExpiredModal';
import StickyNote2Icon from '@mui/icons-material/StickyNote2';
import AddAlertIcon from '@mui/icons-material/AddAlert';
import { useMediaQuery } from '@mui/material';
import { Close as CloseIcon, Diversity1Rounded } from '@mui/icons-material';
import OnDeviceTrainingIcon from '@mui/icons-material/OnDeviceTraining';
import ImportContacts from './Contacts/ImportContacts';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
// import LockIcon from '@mui/icons-material/Lock';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import TrendingDownIcon from '@mui/icons-material/TrendingDown';
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import ContactPageIcon from '@mui/icons-material/ContactPage';

const drawerWidth = 240;
import '../App.css'

const themeColor = '#FFFFFF';

const Main = styled('main', { shouldForwardProp: (prop) => prop !== 'open' })(({ theme, open }) => ({
    flexGrow: 1,
    padding: theme.spacing(3),
    transition: theme.transitions.create('margin', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: `-${drawerWidth}px`,
    ...(open && {
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),
        marginLeft: 0,
    }),
}));

const AppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
    background: themeColor,
    transition: theme.transitions.create(['margin', 'width'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    ...(open && {
        width: `calc(100% - ${drawerWidth}px)`,
        marginLeft: `${drawerWidth}px`,
        transition: theme.transitions.create(['margin', 'width'], {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),
    }),
}));

const DrawerHeader = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    justifyContent: 'flex-end',
}));

export default function Layout() {
    const theme = useTheme();
    const [open, setOpen] = React.useState(true);
    const [openIcaProfileModal, setOpenIcaProfileModal] = React.useState(false);
    const [isIcaAgentOpen, setIsIcaAgentOpen] = useState(false);
    const [isCustomerOpen, setIsCustomerOpen] = useState(false);
    const [getOrganization, setGetOrganization] = useState('');
    const [loading, setLoading] = useState(false);
    const [openDialog, setOpenDialog] = useState(false);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [auth, setAuth] = React.useState(true);
    const { id } = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    const pathname = useLocation().pathname;
    const { isAuthenticated, user } = useSelector((state) => state.auth);
    const userData = JSON.parse(localStorage.getItem('user'));
    const GetOffSet = localStorage.getItem('userOffset');
    const LoginUserID = userData?.user?.organization_id;
    const LoginUserName = userData?.user?.name;
    const LoginUserEmail = userData?.user?.email;
    const LoginUserProfileImage = userData?.user?.profile_image;
    const LoginUserType = userData?.user?.user_type;
    const [logOutModal, setLogOutModal] = useState(false);
    const [openContact, setOpenContact] = useState(false);

    const isMobileOrTablet = useMediaQuery('(max-width:1024px)');
    // Matches screens 1024px and smaller
    const organizationProfile = async (LoginUserID) => {
        try {
            const res = await LeadService.getOrganizationByID(LoginUserID);
            if (res?.data?.success) {
                setGetOrganization(res?.data?.data);
                return;
            }
        } catch (error) {
            console.error(error.message);
            toast.error(error.message);
        }
    };
    const storeUserOffset = () => {
        const offsetInMinutes = new Date().getTimezoneOffset();
        const offsetInHours = -offsetInMinutes / 60; // Convert to hours
        localStorage.setItem('userOffset', offsetInHours);
    };
    useEffect(() => {
        if (LoginUserID && LoginUserType !== 'isa_agent') {
            organizationProfile(LoginUserID);
            storeUserOffset();
        } else if (LoginUserType === 'admin' || LoginUserType === 'isa_agent') {
            storeUserOffset();
        }
    }, [LoginUserID]);

    const SaveTimeZoneOffSet = async (GetOffSet) => {
        try {
            const res = await LeadService.addTimeZone(GetOffSet);
            if (res?.data?.success) {
                console.log(res.data.message);
                return;
            }
        } catch (error) {
            console.error(error.message);
        }
    };
    useEffect(() => {
        if (LoginUserType === 'isa_agent') {
            SaveTimeZoneOffSet(GetOffSet);
        }
    }, [GetOffSet]);

    let sections = [];
    if (userData && userData.user && userData.user.user_type === 'admin') {
        sections = [
            // { name: 'Home', path: '/', icon: <CottageIcon /> },
            // { name: 'Agents', path: '/agents', icon: <Man3Icon sx={{ color: '' }} /> },
            // { name: 'ICA-Agents', path: '/ica-agents', icon: <ManIcon sx={{ color: '' }} /> },
            // { name: 'People', path: '/people', icon: <PeopleIcon sx={{ color: '' }} /> },
            // { name: 'New Agent', path: '/new-agent', icon: <PeopleIcon sx={{ color: '' }} /> },
            // { name: 'New ICA-Agent', path: '/new-ica-agent', icon: <PeopleIcon sx={{ color: '' }} /> },
            // Dashboard

            { name: 'Organization', path: '/', icon: <HomeIcon /> },
            { name: 'Services Menu', path: '/ServicesMenu', icon: <ManageAccountsIcon /> },
            { name: 'Preferred Location', path: '/PreferredLocation', icon: <AddLocationAltIcon /> },
            { name: 'Opportunities ', path: '/jobs', icon: <WorkHistoryIcon sx={{ color: '' }} /> },
            { name: 'Complaint', path: '/complaint', icon: <ReportIcon sx={{ color: '' }} /> },
            { name: 'Promo Message', path: '/promoMessage', icon: <StickyNote2Icon /> },
            { name: 'Push Notification', path: '/customNotification', icon: <AddAlertIcon /> },
            { name: 'Version', path: '/adminVersion', icon: <OnDeviceTrainingIcon /> },
            { name: 'Referral Users', path: '/referral-sales', icon: <Diversity1Icon /> },
            {
                name: 'User',
                icon: <PersonIcon />,
                dropdown: [
                    { name: 'ICA', path: '/organization-ICA', icon: <ManIcon sx={{ color: '' }} /> },
                    { name: 'Agents', path: '/organization-agent', icon: <Man3Icon sx={{ color: '' }} /> },
                    { name: 'Customers', path: '/customers', icon: <PersonSearchIcon sx={{ color: '' }} /> },
                ],
            },
        ];
    } else if (userData && userData.user && userData.user.user_type === 'organization_admin') {
        sections = [
            { name: 'Dashboard', path: '/', icon: <HomeIcon /> },
            {
                name: 'User',
                icon: <PersonIcon />,
                dropdown: [
                    // Apply condition based on LoginUserID
                    LoginUserID === 1
                        ? { name: 'ICA', path: '/ica-agents', icon: <ManIcon sx={{ color: '' }} /> }
                        : { name: 'Managers', path: '/ica-agents', icon: <ManIcon sx={{ color: '' }} /> },
                    { name: 'Agents', path: '/agents', icon: <Man3Icon sx={{ color: '' }} /> },
                    // { name: 'Switch Request', path: '/switch-agent', icon: <Man3Icon sx={{ color: '' }} /> },
                ],
            },
            { name: 'Leads', path: '/admin-Leads', icon: <SupportAgentIcon /> },
            { name: 'Invited Leads', path: '/invited-leads', icon: <PersonAddIcon /> },
            { name: 'Chat', path: '/admin-chat', icon: <ChatIcon /> },
            { name: 'Scheduling', path: '/Scheduling', icon: <CalendarMonthIcon /> },
            { name: 'Alerts', path: '/Admin-Alerts', icon: <NotificationsActiveIcon /> },
        ];
    } else if (userData && userData.user && userData.user.user_type === 'sales') {
        sections = [
            { name: 'All Users', path: '/', icon: <TrendingDownIcon /> },
            { name: 'Create New Agents', path: '/new-sale-users', icon: <Man3Icon /> },
            { name: 'Referral Users', path: '/referral-sales', icon: <Diversity1Icon /> },
        ];
    } else if (userData && userData.user && userData.user.user_type === 'isa_agent') {
        sections = [
            { name: 'DASHBOARD', path: '/', icon: <DashboardIcon /> },
            { name: 'MAP', path: '/map', icon: <MapIcon /> },
            { name: 'LEADS', path: '/get-leads', icon: <BusinessCenterIcon sx={{ color: '' }} /> },
            { name: 'SEARCH', path: '/ica-search', icon: <SearchIcon sx={{ color: '' }} /> },
            { name: 'CHAT', path: '/ica-chat', icon: <ChatIcon sx={{ color: '' }} /> },
            { name: 'ALERTS', path: '/ica-alerts', icon: <NotificationsActiveIcon /> },
        ];
    }
    const handleDrawerOpen = () => {
        setOpen(true);
    };

    const handleDrawerClose = () => {
        setOpen(false);
    };

    const handleClickUser = (section) => {
        if (section.name === 'User') {
            setIsIcaAgentOpen((prevState) => !prevState);
        } else if (section.name === 'CRM') {
            setIsCustomerOpen((prevState) => !prevState);
        }
        // LeadSearch
        localStorage.removeItem('selectedStatus');
        localStorage.removeItem('selectedSource');
        localStorage.removeItem('selectedLead');
        localStorage.removeItem('SaveFilterDate');
        localStorage.removeItem('filters');
        localStorage.removeItem('fromDate');
        localStorage.removeItem('toDate');
        localStorage.removeItem('searchType');
        // SearchLeadAllRoutesJobs
        localStorage.removeItem('selectedCity');
        localStorage.removeItem('isDate');
        localStorage.removeItem('selectedValue');
        // agentTable
        localStorage.removeItem('viewMode');
        sessionStorage.removeItem('agentsMapData');
        //AdminCustomer
        localStorage.removeItem('selectedFilterValue');
        // adminAgent
        localStorage.removeItem('formattedToDate');
        localStorage.removeItem('formattedFromDate');
        localStorage.removeItem('searchTerm');
        localStorage.removeItem('selectedOrganization');
        localStorage.removeItem('selectedTags');
        localStorage.removeItem('sendIDsToAPI');
    };

    const handleClickRemoveLocalStorageUser = () => {
        // LeadSearch
        localStorage.removeItem('selectedStatus');
        localStorage.removeItem('selectedSource');
        localStorage.removeItem('selectedLead');
        localStorage.removeItem('SaveFilterDate');
        localStorage.removeItem('filters');
        localStorage.removeItem('fromDate');
        localStorage.removeItem('toDate');
        localStorage.removeItem('searchType');
        // SearchLeadAllRoutesJobs
        localStorage.removeItem('selectedCity');
        localStorage.removeItem('isDate');
        localStorage.removeItem('selectedValue');
        // agentTable
        localStorage.removeItem('viewMode');
        sessionStorage.removeItem('agentsMapData');
        //AdminCustomer
        localStorage.removeItem('selectedFilterValue');
        // adminAgent
        localStorage.removeItem('formattedToDate');
        localStorage.removeItem('formattedFromDate');
        localStorage.removeItem('searchTerm');
        localStorage.removeItem('SubscriptionDevice');
        localStorage.removeItem('selectedOrganization');
        localStorage.removeItem('selectedTags');
        localStorage.removeItem('sendIDsToAPI');
    };

    const handleMenu = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleClickOpen = () => {
        setOpenDialog(true);
        setAnchorEl(null);
    };
    const handleCloseLogout = () => {
        setOpenDialog(false);
    };

    const dispatch = useDispatch();

    const HandleNavigateHome = () => {
        if (userData.user.user_type === 'admin' || userData?.user?.user_type === 'organization_admin' || userData?.user?.user_type === 'isa_agent') {
            navigate('/');
            return;
        } else if (userData.user.user_type === 'sales') {
            navigate('/');
            return;
        } else {
            toast.error('Something went wrong!');
        }
    };
    const clearAllCookies = (domain) => {
        document.cookie.split(';').forEach((cookie) => {
            // Get cookie name
            const cookieName = cookie.split('=')[0].trim();
            // Clear cookie for the current domain and paths
            document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${domain};`;
            document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=www.${domain};`;
            document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
            document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/subpath; domain=${domain};`;
            document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/subpath;`;
        });
    };

    const clearCookiesOnLogout = () => {
        // Remove cookies for dev environment
        clearAllCookies('iconnct.kind1technology.com');
        // Remove cookies for live environment (IP-based)
        clearAllCookies('iconnctapp.com');
        // Clear localStorage and sessionStorage as well
        localStorage.clear();
        sessionStorage.clear();

        console.log('All cookies, localStorage, and sessionStorage cleared for the specified domains.');
    };

    const handleLogout = async () => {
        const token = localStorage.getItem('token'); // Retrieve the token
        try {
            setLoading(true);
            const res = await logout(token);
            if (res.data.success) {
                setAnchorEl(null);
                if (LoginUserType === 'isa_agent') {
                    setTimeout(() => {
                        navigate('/');
                    });
                } else if (LoginUserType === 'sales') {
                    setTimeout(() => {
                        navigate('/');
                    }, 200);
                } else {
                    setTimeout(() => {
                        navigate('/');
                    }, 200);
                }

                toast.success(res.data.message);
                clearCookiesOnLogout();
                dispatch(LOGOUT());
            }
        } catch (error) {
            if (error.message === 'You have been logged out of the application, please login again to use the application.') {
                setLogOutModal(true);
            } else {
                toast.error(error.message);
            }
        } finally {
            setLoading(false);
            setOpenDialog(false);
        }
    };
    const handleOpenContact = () => {
        setOpenContact(true);
        setAnchorEl(null);
    };

    const handleOpenIcaLeadProfile = () => {
        setAnchorEl(null);
        setOpenIcaProfileModal(true);

    };
    return (
        <Box sx={{ display: 'flex' }}>
            <CssBaseline />
            {isAuthenticated && user ? (
                <>
                    <AppBar elevation={3} position="fixed" open={open} sx={{ background: '#f1f1f1' }}>
                        <Toolbar>
                            <IconButton
                                color="inherit"
                                aria-label="open drawer"
                                onClick={handleDrawerOpen}
                                edge="start"
                                sx={{ color: 'black', mr: 2, ...(open && { display: 'none' }) }}
                            >
                                <MenuIcon />
                            </IconButton>
                            <Box sx={{ flexGrow: 1 }}>{!open && <img src="" style={{ width: '165px' }} />}</Box>
                            {auth && (
                                <div>
                                    <Box style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                                        <Box style={{ padding: '5px', display: 'flex', marginRight: '20px', alignItems: 'center' }}>
                                            <Typography style={{ color: '#A9B4CD', textTransform: 'capitalize ' }}>{LoginUserName}</Typography>
                                        </Box>
                                        <Box style={{ display: 'flex', alignItems: 'center' }}>
                                            <img
                                                src="https://cdn-icons-png.flaticon.com/512/3541/3541871.png"
                                                alt="Icon"
                                                width={40}
                                                height={40}
                                                onClick={handleMenu}
                                                style={{ cursor: 'pointer' }}
                                            />
                                            <KeyboardArrowDownIcon sx={{ color: '#A9B4CD' }} onClick={handleMenu} style={{ cursor: 'pointer' }} />
                                        </Box>
                                    </Box>

                                    <Menu
                                        id="ans-demo-positioned-menu"
                                        aria-labelledby="ans-demo-positioned-button"
                                        anchorEl={anchorEl}
                                        open={Boolean(anchorEl)}
                                        onClose={handleClose}
                                        anchorOrigin={{
                                            vertical: 'top',
                                            horizontal: 'left',
                                        }}
                                        transformOrigin={{
                                            vertical: 'top',
                                            horizontal: 'left',
                                        }}
                                        sx={{
                                            mt: '35px',
                                        }}
                                        PaperProps={{
                                            sx: {
                                                borderRadius: '22px',
                                            },
                                        }}
                                    >
                                        {/* <Box style={{ borderRadius: '12px' }}>
                                            {getUser()?.user_type !== 'admin' && getUser()?.user_type !== 'organization_admin' && (
                                                <MenuItem >
                                                    <Box style={{ width: '200px' }}>
                                                    <ICALeadProfile />
                                                    </Box>
                                                </MenuItem>
                                            )}
                                            {getUser()?.user_type !== 'admin' && getUser()?.user_type !== 'organization_admin' && (
                                                    <MenuItem>
                                                        <ImportContacts />
                                                    </MenuItem>
                                                )}


                                            <MenuItem>
                                                <ContentPasteGoIcon />
                                                <a
                                                    style={{ textDecoration: 'none', color: 'black', fontSize: '15px' }}
                                                    href="https://iconnct.com/terms-conditions/"
                                                    target="_blank"
                                                    rel="noreferrer"
                                                >
                                                    Terms and Condition
                                                </a>
                                            </MenuItem>

                                            <Divider />
                                            <MenuItem>
                                                <Button variant="contained" color="error" fullWidth="true" onClick={handleClickOpen}>
                                                    <LockIcon style={{ color: 'white', fontSize: '14px' }} />  Logout
                                                </Button>
                                            </MenuItem>
                                        </Box> */}

                                        {/* Profile Section */}
                                        <Box display="flex" flexDirection="column" alignItems="center" p={2}>
                                            <Avatar
                                                sx={{ width: 75, height: 75, marginBottom: 1 }}
                                                alt={LoginUserName}
                                                src={`https://iconnctapp.com/` + LoginUserProfileImage}
                                            />

                                            <Typography variant="h6" fontWeight="bold">
                                                {LoginUserName}
                                            </Typography>
                                            <Typography variant="body2" color="text.secondary">
                                                {LoginUserEmail}
                                            </Typography>
                                        </Box>

                                        <Divider sx={{ marginY: 1 }} />
                                        {getUser()?.user_type !== 'admin' &&
                                            getUser()?.user_type !== 'sales' &&
                                            getUser()?.user_type !== 'organization_admin' && (
                                                <MenuItem onClick={handleOpenIcaLeadProfile}>
                                                    <Box style={{ display: 'flex', gap: '2px' }} >
                                                        <Box>
                                                            <AccountBoxIcon />
                                                        </Box>
                                                        <Box>
                                                            <span>Profile</span>
                                                        </Box>
                                                    </Box>
                                                </MenuItem>
                                            )}
                                        {/* {getUser()?.user_type !== 'admin' && getUser()?.user_type !== 'sales' && getUser()?.user_type !== 'organization_admin' && (
                                            <MenuItem onClick={handleOpenContact}>
                                            <Box style={{ display: 'flex' }} >
                                                                <Box>
                                                                    <ContactPageIcon />
                                                                </Box>
                                                                <Box>Contact</Box>
                                                            </Box>
                                            </MenuItem>
                                        )} */}

                                        <MenuItem>
                                            <ContentPasteGoIcon />
                                            <a
                                                style={{ textDecoration: 'none', color: 'black', fontSize: '15px' }}
                                                href="https://iconnct.com/terms-conditions/"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                Terms and Condition
                                            </a>
                                        </MenuItem>
                                        <MenuItem>
                                            <Button variant="contained" color="error" fullWidth="true" onClick={handleClickOpen}>
                                                <LockIcon style={{ color: 'white', fontSize: '14px' }} /> Logout
                                            </Button>
                                        </MenuItem>
                                    </Menu>
                                </div>
                            )}
                            <Dialog
                                open={openDialog}
                                // onClose={handleCloseLogout}
                                PaperProps={{
                                    sx: {
                                        borderRadius: '16px',
                                        boxShadow: '0px 8px 24px rgba(0, 0, 0, 0.15)',
                                        padding: '24px',
                                    },
                                }}
                            >
                                <DialogTitle
                                    sx={{
                                        fontSize: '22px',
                                        fontWeight: 600,
                                        textAlign: 'center',
                                        fontFamily: "'Poppins', sans-serif",
                                        color: '#333',
                                        marginBottom: '12px',
                                    }}
                                >
                                    <Box sx={{ display: 'grid', rowGap: '4px' }}>
                                        <span>Are you sure you want to</span>
                                        <span>log out?</span>
                                    </Box>
                                </DialogTitle>

                                <DialogContent sx={{ padding: '0px' }}>
                                    <DialogContentText
                                        id="alert-dialog-description"
                                        sx={{
                                            textAlign: 'center',
                                            fontFamily: "'Roboto', sans-serif",
                                            color: '#555',
                                            fontSize: '16px',
                                            marginBottom: '24px',
                                            padding: '0px',
                                        }}
                                    >
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                justifyContent: 'center',
                                                gap: '16px',
                                                flexDirection: 'row',
                                                alignItems: 'center',
                                            }}
                                        >
                                            {/* 'No' Button */}
                                            <Button
                                                onClick={handleCloseLogout}
                                                sx={{
                                                    width: '120px',
                                                    height: '50px',
                                                    backgroundColor: '#E3ECF6',
                                                    fontWeight: '500',
                                                    borderRadius: '12px',
                                                    border: '1px solid #587DBF',
                                                    color: '#587DBF',
                                                    fontSize: '16px',
                                                    textTransform: 'none',
                                                    fontFamily: "'Poppins', sans-serif",
                                                    '&:hover': {
                                                        backgroundColor: '#D4E4F3',
                                                    },
                                                }}
                                            >
                                                No
                                            </Button>

                                            {/* 'Yes' Button */}
                                            <Button
                                                id="login-button"
                                                disabled={loading}
                                                onClick={handleLogout}
                                                sx={{
                                                    width: '120px',
                                                    height: '50px',
                                                    backgroundColor: '#5379BD',
                                                    fontWeight: '500',
                                                    borderRadius: '12px',
                                                    color: '#fff',
                                                    fontSize: '16px',
                                                    textTransform: 'none',
                                                    fontFamily: "'Poppins', sans-serif",
                                                    '&:hover': {
                                                        backgroundColor: '#466BA6',
                                                    },
                                                }}
                                                variant="contained"
                                            >
                                                Yes
                                                {loading && (
                                                    <CircularProgress
                                                        size={24}
                                                        sx={{
                                                            color: 'white',
                                                            marginLeft: '8px',
                                                        }}
                                                    />
                                                )}
                                            </Button>
                                        </Box>
                                    </DialogContentText>
                                </DialogContent>
                            </Dialog>
                        </Toolbar>
                    </AppBar>

                    {/* {isMobileOrTablet && (
                        <IconButton onClick={handleDrawerOpen} sx={{ position: 'absolute', top: 10, left: 10, color: 'white', zIndex: 1300 }}>
                            {open ? <CloseIcon /> : <MenuIcon style={{ color: 'grey' }} />}
                        </IconButton>
                    )} */}

                    <Drawer
                        sx={{
                            width: drawerWidth,
                            flexShrink: 0,
                            '& .MuiDrawer-paper': {
                                width: drawerWidth,
                                boxSizing: 'border-box',
                                border: 'none',
                                background: 'linear-gradient(#26c7f3, #316ec1)',
                                '&::-webkit-scrollbar': {
                                    height: '6px', // Horizontal scrollbar height
                                    width: '6px', // Vertical scrollbar width
                                },
                                '&::-webkit-scrollbar-thumb': {
                                    backgroundColor: '#c1c1c1', // Scrollbar thumb color
                                    borderRadius: '10px', // Rounded scrollbar thumb
                                },
                                '&::-webkit-scrollbar-track': {
                                    backgroundColor: '#f1f1f1', // Scrollbar track color
                                },
                            },
                        }}
                        variant={isMobileOrTablet ? 'temporary' : 'persistent'} // Use temporary for mobile and tablet screens
                        anchor="left"
                        open={open}
                        onClose={handleDrawerClose}
                    >
                        <DrawerHeader
                            sx={{ background: '#F1F1F1', borderBottom: '0px solid #A9B4CD', cursor: 'pointer' }}
                            onClick={HandleNavigateHome}
                        >
                            {userData?.user?.user_type === 'admin' ? (
                                <img src={Super_admin} style={{ marginRight: '15px', width: '85%' }} />
                            ) : userData?.user?.user_type === 'organization_admin' ? (
                                <>
                                    {' '}
                                    <Avatar
                                        alt={userData?.user?.name}
                                        src={`https://iconnctapp.com/` + getOrganization?.profile_image}
                                        style={{ marginRight: '3px', textTransform: 'capitalize' }}
                                    />{' '}
                                    <img src={Originaztion_admin} style={{ marginRight: '20px', width: '70%' }} />
                                </>
                            ) : userData?.user?.user_type === 'sales' ? (
                                <img src={LogoSales} style={{ marginRight: '15px', width: '85%' }} />
                            ) : (
                                <img src={logoAgent} style={{ marginRight: '15px', width: '85%' }} />
                            )}

                            {/* <IconButton onClick={handleDrawerClose}>
                                {theme.direction === 'ltr' ? (
                                    <ChevronLeftIcon sx={{ color: 'white' }} />
                                ) : (
                                    <ChevronRightIcon sx={{ color: 'white' }} />
                                )}
                            </IconButton> */}
                        </DrawerHeader>
                        <Divider />
                        <List>
                            {/* <Divider
                                sx={{
                                    mt: 2,
                                    '&::before, &::after': {
                                        borderColor: 'orange',
                                    },
                                }}
                            >
                                <Chip sx={{ color: 'white' }} label="List" size="small" />
                            </Divider> */}
                            <>
                                {sections?.map((text, index) => {
                                    const isSelected =
                                        text.path === '/'
                                            ? pathname === text.path
                                            : pathname.startsWith(text.path) ||
                                              (text.path === '/admin-Leads' && pathname.includes('admin-leads-details'));

                                    return (
                                        <React.Fragment key={index}>
                                            <ListItem key={index} disablePadding onClick={() => navigate(text.path)}>
                                                <ListItemButton
                                                    onClick={() => handleClickUser(text)}
                                                    sx={{
                                                        background: isSelected ? '#6CD0E7' : 'none',
                                                        boxShadow: isSelected
                                                            ? 'rgba(0, 0, 0, 0.1) 0px 0px 5px 0px, rgba(0, 0, 0, 0.1) 0px 0px 1px 0px'
                                                            : 'none',
                                                        '&:hover': {
                                                            background: '#6CD0E7',
                                                            boxShadow: 'rgba(0, 0, 0, 0.25) 0px 25px 50px -12px',
                                                        },
                                                    }}
                                                >
                                                    <ListItemIcon
                                                        // onClick={() => navigate(text.path)}
                                                        sx={{ color: 'white', minWidth: '40px' }}
                                                    >
                                                        {text.icon}
                                                    </ListItemIcon>
                                                    <ListItemText
                                                        sx={{ color: 'white' }}
                                                        // onClick={() => navigate(text.path)}
                                                        primaryTypographyProps={{ textDecoration: 'none', fontSize: '16px', fontWeight: 600 }}
                                                        to={text.path}
                                                        primary={text.name}
                                                    />
                                                    {location.pathname === text.path && <KeyboardArrowRightIcon sx={{ color: 'white' }} />}
                                                    {text.customers && <KeyboardArrowDownIcon sx={{ color: '#babcc1' }} />}

                                                    {text.dropdown && <KeyboardArrowDownIcon sx={{ color: '#858993' }} />}
                                                </ListItemButton>
                                            </ListItem>
                                            {/* {text.dropdown && (
                                        <Collapse in={isIcaAgentOpen}>
                                            <List component="div" disablePadding dense>
                                                {text.dropdown.map((item) => (
                                                    <ListItemButton key={item.name} sx={{ background: location.pathname === item.path ? 'linear-gradient(90deg, #83ADD7 21.14%, rgba(201, 200, 255, 0) 78.25%)' : 'none' }}>
                                                        <ListItemIcon
                                                            onClick={() => navigate(item.path)}
                                                            sx={{ color: location.pathname === `${item.path}` ? '#5379BD' : '#A9B4CD', marginLeft:'50px' }}>
                                                            {item.icon}
                                                        </ListItemIcon>
                                                        <ListItemText
                                                            sx={{ color: location.pathname === `${item.path}` ? '#5379BD' : '#A9B4CD' }}
                                                            onClick={() => navigate(item.path)}
                                                            primaryTypographyProps={{ textDecoration: 'none', fontSize: '14px', fontWeight: 'bold' }}
                                                            primary={item.name} to={item.path} />
                                                    </ListItemButton>
                                                ))}
                                            </List>
                                        </Collapse>
                                    )} */}
                                            {text?.dropdown && (
                                                <Collapse in={isIcaAgentOpen}>
                                                    <List onClick={handleClickRemoveLocalStorageUser} component="div" disablePadding dense>
                                                        {text?.dropdown?.map((item) => {
                                                            // const isSelected = pathname.slice(0, item.path.length) === item.path;
                                                            const isSelected =
                                                                pathname.startsWith(item.path) ||
                                                                (item.path === '/ica-agents' && pathname.includes('/isa-agent-details/'));
                                                            console.log(isSelected, '213411111a');
                                                            return (
                                                                <>
                                                                    <ListItemButton
                                                                        key={item.name}
                                                                        sx={{
                                                                            background: isSelected ? '#6CD0E7' : 'none',

                                                                            '&:hover': {
                                                                                background: '#6CD0E7',
                                                                            },
                                                                        }}
                                                                    >
                                                                        <ListItemIcon
                                                                            onClick={() => navigate(item.path)}
                                                                            sx={{ color: 'white', marginLeft: '20px', minWidth: '40px' }}
                                                                        >
                                                                            {item.icon}
                                                                        </ListItemIcon>
                                                                        <ListItemText
                                                                            sx={{ color: 'white' }}
                                                                            onClick={() => navigate(item.path)}
                                                                            primaryTypographyProps={{
                                                                                textDecoration: 'none',
                                                                                fontSize: '14px',
                                                                                fontWeight: 'bold',
                                                                            }}
                                                                            primary={item.name}
                                                                            to={item.path}
                                                                        />
                                                                    </ListItemButton>
                                                                </>
                                                            );
                                                        })}
                                                    </List>
                                                </Collapse>
                                            )}

                                            {/* {text.customers && (
                                        <Collapse in={isCustomerOpen}>
                                            <List component="div" disablePadding dense>
                                                {text.customers.map((item) => (
                                                    <ListItemButton key={item.name} sx={{ background: location.pathname === item.path ? 'linear-gradient(90deg, #83ADD7 21.14%, rgba(201, 200, 255, 0) 78.25%)' : 'none' }}>
                                                        <ListItemIcon
                                                            onClick={() => navigate(item.path)}
                                                            sx={{ color: location.pathname === `${item.path}` ? '#5379BD' : '#A9B4CD', marginLeft: '50px' }}>
                                                            {item.icon}
                                                        </ListItemIcon>
                                                        <ListItemText
                                                            sx={{ color: location.pathname === `${item.path}` ? '#5379BD' : '#A9B4CD' }}
                                                            onClick={() => navigate(item.path)}
                                                            primaryTypographyProps={{ textDecoration: 'none', fontSize: '14px', fontWeight: 'bold' }}
                                                            primary={item.name} to={item.path} />
                                                    </ListItemButton>
                                                ))}
                                            </List>
                                        </Collapse>
                                    )} */}
                                            {text.customers && (
                                                <Collapse in={isCustomerOpen}>
                                                    <List onClick={() => handleClickUser(text)} component="div" disablePadding dense>
                                                        {text?.customers?.map((item) => {
                                                            const isSelected =
                                                                pathname.startsWith(item.path) ||
                                                                (item.path === '/jobs' && pathname.includes('/admin-job-details/'));
                                                            return (
                                                                <>
                                                                    <ListItemButton
                                                                        key={item.name}
                                                                        sx={{
                                                                            background: isSelected
                                                                                ? 'linear-gradient(90deg, #4570c5f0 41.14%, rgb(190 204 230) 94.25%)'
                                                                                : 'none',
                                                                            boxShadow: isSelected ? 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px' : 'none',
                                                                            borderRadius: isSelected ? '15px' : 'none',
                                                                        }}
                                                                    >
                                                                        <ListItemIcon
                                                                            onClick={() => navigate(item.path)}
                                                                            sx={{ color: isSelected ? 'white' : '#A9B4CD', marginLeft: '50px' }}
                                                                        >
                                                                            {item.icon}
                                                                        </ListItemIcon>
                                                                        <ListItemText
                                                                            sx={{ color: isSelected ? 'white' : '#A9B4CD' }}
                                                                            onClick={() => navigate(item.path)}
                                                                            primaryTypographyProps={{
                                                                                textDecoration: 'none',
                                                                                fontSize: '14px',
                                                                                fontWeight: 'bold',
                                                                            }}
                                                                            primary={item.name}
                                                                            to={item.path}
                                                                        />
                                                                    </ListItemButton>
                                                                </>
                                                            );
                                                        })}
                                                    </List>
                                                </Collapse>
                                            )}
                                            {/* {text.path === '/people' ? (
                                        <Divider
                                            sx={{
                                                mt: 2,
                                                '&::before, &::after': {
                                                    borderColor: 'orange',
                                                },
                                            }}
                                        >
                                            <Chip sx={{ color: 'white' }} label="New" size="small" />
                                        </Divider>
                                    ) : (
                                        ''
                                    )} */}
                                        </React.Fragment>
                                    );
                                })}
                            </>
                        </List>
                    </Drawer>

                    <div sx={{ p: 2 }} open={open} style={{ background: '#F8FAFB', minHeight: '100vh' }} className='ans-main-app-sec'>
                        <DrawerHeader />
                        {GetRoutes(isAuthenticated, user)}
                        {/* Footer */}
                    </div>
                </>
            ) : (
                GetRoutes(isAuthenticated, user)
            )}
            <LogoutExpiredModal setLogOutModal={setLogOutModal} logOutModal={logOutModal} />
            <ImportContacts
                setOpenContact={setOpenContact}
                openContact={openContact}
                handleOpenContact={handleOpenContact}
                setAnchorEl={setAnchorEl}
            />

            <ICALeadProfile openIcaProfileModal={openIcaProfileModal} setOpenIcaProfileModal={setOpenIcaProfileModal} setAnchorEl={setAnchorEl} />
        </Box>
    );
}
